module.exports = __webpack_public_path__ + "static/media/yakuza-cover.40a8be3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/Yakuza/yakuza-cover.jpg
// module id = 593
// module chunks = 0